import type { WebSourceFilterProps } from "@similarweb/pro-logic-components/dist/table/components/TableTop/QueryFilters/WebSource";

import { translate } from "app/filters/i18nFilter";

import { useDisplayAdvertiserPublisherDataAndParams } from "./useDisplayAdvertiserPublisherDataAndParams";

export const useWebSourceSubtitleFilter = (webSourceOverride?: WebSourceFilterProps["value"]) => {
    const params = useDisplayAdvertiserPublisherDataAndParams();
    const { webSource } = params;
    const currentWebSource = webSourceOverride ?? webSource;
    const webSourceDisplayName = `websources.${currentWebSource.toLowerCase()}`;

    return {
        filter: "webSource" as const,
        value: currentWebSource,
        displayName: translate(webSourceDisplayName),
    };
};
